import { useAuthorizedQuery } from "..";
import { params } from "../../params";
import { TenantBrand } from "@/v2/entities/brand/Brand.model";

export const useBrands = (enabled = true) => {
  return useAuthorizedQuery<TenantBrand[]>({
    queryKey: "brands",
    url: `${params.API_URL}/platform/tenant-brand`,
    method: "GET",
    enabled,
  });
};
